<script>
import { Radar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  extends: Radar,
  mixins: [reactiveProp],
  // props: ['options'],

  data() {
    return {
      options: {
        backgroundColor: 'red',
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        elements: {
          point: {
            pointRadius: 0,
            display: false,
            pointBackgroundColor: '#6C7BE6',
            borderWidth: 1,
            backgroundColor: '#6C7BE6',
            hitRadius: 10,
          },
          line: {
            fill: false,
            backgroundColor: '#6b79e6',
            borderColor: '#6C7BE6',
            borderJoinStyle: 'miter',
          },
        },
        scale: {
          angleLines: {
            display: true,
          },
          ticks: {
            display: false,
            suggestedMin: 0,
            suggestedMax: 7,
          },
          pointLabels: {
            fontStyle: 'bold',
            fontColor: 'black',
          },
        },
        tooltips: {
          enabled: false,
          display: false,
        },
      },
    };
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>

<style lang="scss" scoped></style>
